export default __webpack_public_path__ + "static/media/Google-play.dfa3558f.png";